<ng-template #filterTemplate let-modal="modal">
    <div class="position-absolute top-0 d-flex flex-column flex-grow w-100 h-100 pt-lg-3">
        <div class="px-4 pt-4 position-relative flex-grow h-100">
            <div class="position-relative flex-grow h-100">
                <div class="d-flex justify-content-between">
                    <h5 class="text-blue fw-bolder my-0">Filter</h5>
                    <p class="fw-light">{{ organizationResultsSummary }}</p>
                </div>

                <div class="filters-container pt-5 position-absolute flex-grow w-100 h-100 top-0">
                    <div class="overflow-auto p-0 m-0 w-100 h-100">
                        <div *ngFor="let field of filterableFields">
                            <h6 class="text-blue fw-light mb-2">{{ fieldsNicknames[field] || field | titleCaseWord }}</h6>
                            <div class="fancy-checkbox" [ngClass]="{ 'mb-4': i === filterableValues[field].length - 1 }" *ngFor="let value of filterableValues[field]; index as i">
                                <input type="checkbox" id="{{ value }}" [checked]="isFilterableFieldActive(field, value)" (change)="toggleFilterableField(field, value)" />
                                <label for="{{ value }}">{{ value }}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="buttons d-flex justify-content-between p-4 z-4">
            <button class="btn btn-white" (click)="clearFilter()">Clear</button>
            <button class="btn btn-green" (click)="applyFilter()">Apply</button>
        </div>
    </div>
</ng-template>

<div class="accounts-wrapper disease-gradient-section position-relative py-5">
    <div class="background-gradient background-gradient--subtle-circles d-print-none" aria-hidden="true">
        <div class="circle-top-left"></div>
        <div class="circle-lower-right"></div>
    </div>
    <div class="container-xxxl px-0 px-lg-3">
        <div class="d-flex justify-content-between flex-sm-row flex-column mb-4 py-xl-5">
            <h3 class="fw-bolder text-white mb-sm-0 fs-md-2 px-4 px-xl-0">{{ patientOrgainationTitle }}</h3>
            <div class="options d-flex gap-2 px-4 justify-content-sm-end align-items-center d-print-none">
                <button class="btn text-white filter py-2 px-3" (click)="openFilterModal()"><i class="icon-gard-filter"></i> Filter</button>
                <div class="button-divider"></div>
                <button class="btn text-white download py-2 px-3" (click)="download()"><i class="icon-gard-download"></i> Download</button>
            </div>
        </div>

        <p class="text-white fw-light d-block mb-2 mb-xl-4 px-4 px-xl-0" aria-live="polite">{{ organizationResultsSummary }}</p>

        <div class="interactive-table position-relative d-print-none">
            <div class="head mb-4 py-2 d-none d-xl-block">
                <div class="row gx-0 text-green fw-bolder py-1 px-3">
                    <div class="col-xl-5">
                        <button type="button" class="bg-transparent border-0 text-green fw-bolder text-start p-0" (click)="sortBy('name')">
                            Organization Name
                            <i
                                class="text-green"
                                [ngClass]="[sortState.field === nameProperty ? (sortState.asc ? 'icon-gard-sort-up' : 'icon-gard-sort-down') : 'icon-gard-sort']"
                            ></i>
                        </button>
                    </div>
                    <div class="col-xl-3 who-they-serve">
                        <button type="button" class="bg-transparent border-0 text-green fw-bolder text-start p-0" (click)="sortBy('serveOrder')">
                            Who They Serve
                            <i
                                class="text-green"
                                [ngClass]="[sortState.field === serveOrderProperty ? (sortState.asc ? 'icon-gard-sort-up' : 'icon-gard-sort-down') : 'icon-gard-sort']"
                            ></i>
                        </button>
                    </div>
                    <div class="col-xl-3 service-title">
                        <button type="button" class="bg-transparent border-0 text-green fw-bolder text-start p-0" (click)="sortBy('linkOrder')">
                            Helpful Links
                            <i
                                class="text-green"
                                [ngClass]="[sortState.field === linkOrderProperty ? (sortState.asc ? 'icon-gard-sort-up' : 'icon-gard-sort-down') : 'icon-gard-sort']"
                            ></i>
                        </button>
                    </div>
                    <div class="col-xl-1">
                        <button type="button" class="bg-transparent border-0 text-green fw-bolder text-start p-0" (click)="sortBy('country')">
                            Country
                            <i
                                class="text-green"
                                [ngClass]="[sortState.field === countryProperty ? (sortState.asc ? 'icon-gard-sort-up' : 'icon-gard-sort-down') : 'icon-gard-sort']"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="body d-flex flex-row flex-xl-column" (scroll)="onScroll()">
                <div class="item mb-0 mb-xl-2 me-4 me-xl-0" *ngFor="let organization of organizations; let f = first" [ngClass]="{ 'ms-4 ms-xl-0': f }">
                    <div class="row gx-xl-0 align-items-center py-0 py-xl-1 px-0 px-xl-3">
                        <div class="org-name col-xl-5 py-4 py-xl-0 px-4 px-xl-0 flex-fill pb-3 pb-xl-0">
                            <a link [attr.href]="organization.url" target="_blank" rel="noopener">
                                <h4 class="d-inline fw-bolder mb-2 mb-xl-3 w-75 fs-md-22 me-1">{{ organization.name }}</h4>
                            </a>
                        </div>
                        <div class="col-xl-3 who-they-serve py-3 py-xl-0 px-4 px-xl-0 mb-2 mb-xl-0">
                            <div class="text-blue fw-bolder mb-2 fs-6 fs-md-18">People With</div>
                            <p class="fs-md-18">{{ organization.whoTheyServe }}</p>
                        </div>
                        <div class="col-xl-3 py-2 pt-0 py-xl-0 px-4 px-xl-0 mb-2 mb-xl-0 service-title z-10">
                            <div class="d-block d-xl-none text-green mb-2 fw-bolder" *ngIf="organization.expertDirectoryUrl || organization.patientRegistryUrl">Helpful Links</div>
                            <div class="d-flex flex align-items-start text-center fs-6">
                                <div *ngIf="organization.expertDirectoryUrl">
                                    <i class="icon-gard-information icon-circle text-blue"></i>
                                    <div class="icon-text">
                                        <a class="text-link" [href]="organization.expertDirectoryUrl" link>List of Experts</a>
                                    </div>
                                </div>
                                <div *ngIf="organization.patientRegistryUrl">
                                    <i class="icon-gard-research icon-circle text-green"></i>
                                    <div class="icon-text">
                                        <a class="text-link" [href]="organization.patientRegistryUrl" link>Research Registry</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-1 py-2 py-xl-0 px-4 px-xl-0 mb-2 mb-xl-0">
                            <div class="fw-bolder mb-2 d-block d-xl-none s-md-18 text-green">Country</div>
                            <p class="fs-md-18">
                                {{ organization.country }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <table class="d-none d-print-table table table-sm table-bordered w-100 mb-0" style="table-layout: fixed" *ngIf="organizations.length">
            <colgroup>
                <col style="width: 32%" />
                <col style="width: 23%" />
                <col style="width: 27%" />
                <col style="width: 18%" />
            </colgroup>
            <thead class="table-light">
                <tr>
                    <th scope="col">Organization</th>
                    <th scope="col">People With</th>
                    <th scope="col">Helpful Links</th>
                    <th scope="col">Country</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let organization of organizations">
                    <td>
                        <a link [attr.href]="organization.url" target="_blank" rel="noopener">{{ organization.name }}</a>
                    </td>
                    <td>{{ organization.whoTheyServe }}</td>
                    <td>
                        <a *ngIf="organization.expertDirectoryUrl" [href]="organization.expertDirectoryUrl" link>List of Experts</a>
                        <span *ngIf="organization.expertDirectoryUrl && organization.patientRegistryUrl"><br /></span>
                        <a *ngIf="organization.patientRegistryUrl" [href]="organization.patientRegistryUrl" link>Research Registry</a>
                    </td>
                    <td>{{ organization.country }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
